import { render, staticRenderFns } from "./PallettePicker.vue?vue&type=template&id=4535af70&scoped=true"
import script from "./PallettePicker.vue?vue&type=script&lang=js"
export * from "./PallettePicker.vue?vue&type=script&lang=js"
import style0 from "./PallettePicker.vue?vue&type=style&index=0&id=4535af70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535af70",
  null
  
)

export default component.exports